var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useInterval } from "react-use";
var Countdown = function (_a) {
    var className = _a.className;
    var getCountdown = function () {
        var now = new Date();
        var updateTime = new Date(+now);
        // Time until 5am UTC
        var timeRemaining = 60 * 60 * 24 * 1000 -
            (now.getTime() - updateTime.setUTCHours(8, 0, 0, 0));
        var time = new Date(timeRemaining).toISOString().slice(11, 19); // HH:MM:SS
        return time;
    };
    var _b = useState(getCountdown()), countdown = _b[0], setCountdown = _b[1];
    useInterval(function () {
        var updatedTime = getCountdown();
        setCountdown(updatedTime);
    }, 1000);
    return (_jsxs("div", __assign({ className: className }, { children: ["The next daily puzzle will be available in: ", _jsx("h4", { children: countdown }, void 0)] }), void 0));
};
export default Countdown;
